import { render, staticRenderFns } from "./UnpaidRequisitionItemsModal.vue?vue&type=template&id=accdf4a0&scoped=true&"
import script from "./UnpaidRequisitionItemsModal.vue?vue&type=script&lang=ts&"
export * from "./UnpaidRequisitionItemsModal.vue?vue&type=script&lang=ts&"
import style0 from "./UnpaidRequisitionItemsModal.vue?vue&type=style&index=0&id=accdf4a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accdf4a0",
  null
  
)

export default component.exports